
// --- Vue & Template imports ---
import { Component, Vue, Watch} from 'vue-property-decorator';

// --- Models ---
import { Report } from '@/models/Report.model';

// --- Services ---
import AppService from '@/services/app';
import ReportService from '@/services/report';

// --- Third Party ---

@Component
export default class ReportScheduleListing extends Vue {

  // used by No Data Slot
  isLoading: boolean = true;

  clickedItem: Report = {
    id: 0,
    reportTypeId: 0,
    reportType: '',
    frequency: '',
    defaultEmailAddress: '',
    lastRun: '',
    nextRun: '',
  }

  isUpdate: boolean = false;

  // used by Dialog for Email Report
  showEmailDialog: boolean = false;
  emailDialogTitle: string = '';
  emailValid: boolean = false;
  toEmailAddress: string = '';
  emailClicked: boolean = false;

  rules = {
    required: (value: string) => !!value || '',
    email: (value: string) => /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value) || 'E-mail must be valid',
  };

  // #region Functions to display list data on page load
    headers() {
      return [
        {
          text: '#',
          value: 'reportTypeId',
        },
        {
          text: 'Type',
          value: 'reportType',
        },
        {
          text: 'Descritpion',
          value: 'description',
        },
        {
          text: 'Default Email Address',
          value: 'defaultEmailAddress',
        },
        {
          text: 'Frequency',
          value: 'frequency',
        },
        {
          text: 'Last Run',
          value: 'lastRun',
        },
        {
          text: 'Next Run',
          value: 'nextRun',
        },
        {
          sortable: false,
          text: '',
          value: 'action',
          align: 'end',
        },
      ];
    }

    async beforeMount() {
      await this.listAll();
    }

    async listAll() {
      try {
        this.isLoading = true;
        const response: string = await ReportService.listScheduled(true);

        if (response.length > 0 && response !== 'No Data Found') {
          AppService.errorHandler(response);
        }

      } finally {
        this.isLoading = false;
      }
    }

    allowEditFunctionality() {
      return this.$store.getters['app/allowAccess'](this.$store.getters['users/loggedInUser'], [
        { type: 'Super User', level: 5},
      ]);
    }

    allowEmailFunctionality() {
      return this.$store.getters['app/allowAccess'](this.$store.getters['users/loggedInUser'], [
        { type: 'Super User', level: 2},
        { type: 'Operator', level: 3},
      ]);
    }
  // #endregion

  // #region Functions required for the Dialog to Update / Email Report
    async launchUpdateItemDialog(item: Report) {
      this.clickedItem = item;
      this.isUpdate = true;

      this.emailValid = false;
      this.toEmailAddress = this.clickedItem.defaultEmailAddress;
      this.emailDialogTitle = 'Udpate ' + this.clickedItem.reportType;

      if (this.$refs.itemForm) {
        (this.$refs.itemForm as any).resetValidation();
      }

      this.showEmailDialog = true;
    }

    async launchEmailDialog(item: Report) {
      this.clickedItem = item;
      this.isUpdate = false;

      this.emailValid = false;
      this.toEmailAddress = '';
      this.emailDialogTitle = 'Email ' + this.clickedItem.reportType;

      if (this.$refs.itemForm) {
        (this.$refs.itemForm as any).resetValidation();
      }

      this.showEmailDialog = true;
    }

    async doEmailOrUpdate() {
      if (this.isUpdate) {
        await this.doUpdate();
      } else {
        await this.emailReport();
      }
    }

    async doUpdate() {
      try {
        this.emailClicked = true;

        const response = await ReportService.update({
          id: this.clickedItem.id,
          emailAddress: this.toEmailAddress,
        });

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            AppService.successHandler(response.data.message);
            this.listAll();
            this.showEmailDialog = false;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('ReportSchedule.vue - doUpdate - 336 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.emailClicked = false;
      }
    }

    async emailReport() {
      try {
        this.emailClicked = true;

        const response = await ReportService.create({
          reportType: this.clickedItem.reportTypeId,
          title: this.clickedItem.reportType,
          emailAddress: this.toEmailAddress,
        });

        if (response && response.data) {
          if (response.data.result && response.data.result === 'false') {
            AppService.errorHandler(response.data.message);
          } else {
            AppService.successHandler(response.data.message);
            this.showEmailDialog = false;
          }
        } else {
          // response is undefined or has no data field - SHOULD NEVER HAPPEN!
          throw new Error('response: ' + JSON.stringify(response));
        }

      } catch (error) {
        if (error.response) {
          AppService.errorHandler(error.response.statusText);
        } else {
          AppService.logSupportDebug('ReportSchedule.vue - emailReport - 371 - ' + error);
          AppService.errorHandler(this.$store.getters['app/messages'].couldNotConnect);
        }

      } finally {
        this.emailClicked = false;
      }
    }
  // #endregion

}
